function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var DetailsTemplate = require('./details.template');
var SaitoTokenOverlay = require('./saito-acquisition.template');
var SaitoOverlay = require('./../../saito-overlay/saito-overlay');
var SaitoLoader = require('./../../saito-loader/saito-loader');
var Details = /*#__PURE__*/function () {
  function Details(app, mod) {
    var _this = this;
    _classCallCheck(this, Details);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(this.app, this.mod);
    this.overlay["class"] = 'saito-overlay bottom-mobile-overlay';
    this.loader = new SaitoLoader(this.app, this.mod, '#saito-details-loader');
    app.connection.on('saito-crypto-details-render-request', function (ticker) {
      _this.ticker = ticker;
      _this.mod = _this.app.wallet.returnCryptoModuleByTicker(ticker);
      _this.render();
    });
    app.connection.on('saito-crypto-activated', function (ticker) {
      if (ticker == _this.ticker && _this.overlay.visible) {
        _this.render();
      }
    });
  }
  return _createClass(Details, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var qrcode_html = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.overlay.show(DetailsTemplate(this.app, this.mod));

      // Insert deposit QR code
      if (document.getElementById('qrcode2')) {
        if (qrcode_html) {
          document.querySelector('#qrcode2').innerHTML = qrcode_html;
        } else {
          document.querySelector('#qrcode2').style.visibility = 'hidden';
          document.querySelector('#qrcode2').style.opacity = '0';
          document.querySelector('#qrcode2').innerHTML = '';
          this.app.browser.generateQRCode(this.mod.address, 'qrcode2');
          setTimeout(function () {
            document.querySelector('#qrcode2').removeAttribute('style');
          }, 100);
        }
      }
      setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var balance;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _this2.app.wallet.getBalance();
            case 1:
              balance = _context.v;
              if (Number(balance) == 0 && document.querySelector('.get-saito-tokens')) {
                _this2.app.modules.renderInto('.get-saito-tokens');
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      })), 0);
      this.loader.remove();
      this.formatHistory();
      this.attachEvents();
    }
  }, {
    key: "formatHistory",
    value: function formatHistory() {
      var _this$mod$history, _this$mod$history2;
      var history_html = '';
      var running_balance = Number(this.mod.returnBalance());
      if (this.ticker == 'SAITO') {
        document.documentElement.style.setProperty('--saitox-column-ct', 6);
      } else {
        document.documentElement.style.setProperty('--saitox-column-ct', 5);
      }
      if (!((_this$mod$history = this.mod.history) !== null && _this$mod$history !== void 0 && _this$mod$history.length) && running_balance == 0) {
        console.log('No history to format or interpolate');
        return;
      }
      var day = new Date().toDateString();
      var last_ts = 0;
      if (((_this$mod$history2 = this.mod.history) === null || _this$mod$history2 === void 0 ? void 0 : _this$mod$history2.length) > 0) {
        console.log('Formatting HISTORY: ', this.mod.history);

        // Go backwards in time
        for (var i = this.mod.history.length - 1; i >= 0; i--) {
          var _h$counter_party, _h$counter_party2;
          var h = this.mod.history[i];
          if (h.timestamp == last_ts) {
            console.warn('Duplicate entries!');
            continue;
          }
          last_ts = h.timestamp;
          var ts = new Date(h.timestamp);
          var inner_html = '';
          if (ts.toDateString() !== day) {
            day = ts.toDateString();
            inner_html += "<div class=\"saitox-table-break\">".concat(day, "</div>");
          }
          inner_html += "<div class=\"crypto-timestamp\">".concat(ts.toLocaleTimeString(), "</div>\n                          <div class=\"crypto-type\">").concat(h.type, "</div>\n                          <div class=\"crypto-amount\">").concat(this.app.browser.formatDecimals(h.amount), "</div>\n                          <div class=\"crypto-amount\">").concat(this.app.browser.formatDecimals(running_balance), "</div>");
          if ((_h$counter_party = h.counter_party) !== null && _h$counter_party !== void 0 && _h$counter_party.publicKey) {
            inner_html += this.app.browser.returnAddressHTML(h.counter_party.publicKey);
          } else if ((_h$counter_party2 = h.counter_party) !== null && _h$counter_party2 !== void 0 && _h$counter_party2.address) {
            if (h.counter_party.address.indexOf('-') > 0) {
              var mixin_address = h.counter_party.address.split('-');
              inner_html += "<div class=\"crypto-address\" title=\"mixin internal address\">".concat(mixin_address[0], "--").concat(mixin_address[mixin_address.length - 1], "</div>");
            } else {
              inner_html += "<div class=\"crypto-address\" data-address=\"".concat(h.counter_party.address, "\">").concat(h.counter_party.address.slice(0, 6), "...").concat(h.counter_party.address.slice(-8), "</div>");
            }
          } else {
            inner_html += '<div></div>';
          }
          inner_html += "<div class=\"saito-only\">".concat((h === null || h === void 0 ? void 0 : h.memo) || '', "</div>");
          history_html += inner_html;
          running_balance -= Number(h.amount);
          //
          // Round off to correct any crazy float operations bullshit
          //
          running_balance = Number(running_balance.toFixed(8));
        }
      }
      if (running_balance > 0) {
        history_html += "<div class=\"crypto-timestamp\"></div>\n                          <div class=\"crypto-type\">deposit</div>\n                          <div class=\"crypto-amount\">".concat(this.app.browser.formatDecimals(running_balance), "</div>\n                          <div class=\"crypto-amount\">").concat(this.app.browser.formatDecimals(running_balance), "</div>\n                          <div class=\"crypto-address\">Starting balance</div>\n                          ");
      }
      this.app.browser.addElementToSelector(history_html, '.transaction-history-table.saitox-table');
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this3 = this;
      if (document.getElementById('activate-now')) {
        document.getElementById('activate-now').onclick = function (e) {
          _this3.loader.render();
          _this3.app.wallet.setPreferredCrypto(_this3.ticker);
        };
      }
      Array.from(document.querySelectorAll('.pubkey-container')).forEach(function (element) {
        return element.onclick = /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(e) {
            var public_key, icon_element;
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.n) {
                case 0:
                  public_key = document.getElementById('profile-public-key').dataset.add;
                  _context2.n = 1;
                  return navigator.clipboard.writeText(public_key);
                case 1:
                  icon_element = element.querySelector('i.fa-copy');
                  icon_element.classList.toggle('fa-copy');
                  icon_element.classList.toggle('fa-check');
                  setTimeout(function () {
                    icon_element.classList.toggle('fa-copy');
                    icon_element.classList.toggle('fa-check');
                  }, 800);
                case 2:
                  return _context2.a(2);
              }
            }, _callee2);
          }));
          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }();
      });
      if (document.getElementById('send-crypto')) {
        document.getElementById('send-crypto').onclick = function (e) {
          if (Number(_this3.mod.balance) > 0) {
            _this3.app.connection.emit('saito-crypto-withdraw-render-request', {
              ticker: _this3.ticker
            });
          }
        };
      }
      if (document.getElementById('get-saito')) {
        document.getElementById('get-saito').onclick = function (e) {
          _this3.app.connection.emit('saito-purchase-launch');
          //let overlay = new SaitoOverlay(this.app, this.mod);
          //overlay.show(SaitoTokenOverlay());
        };
      }
      if (document.getElementById('check-balance')) {
        document.getElementById('check-balance').onclick = /*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(e) {
            var _document$querySelect;
            var balance;
            return _regenerator().w(function (_context3) {
              while (1) switch (_context3.n) {
                case 0:
                  e.currentTarget.classList.add('refreshing');
                  _context3.n = 1;
                  return _this3.mod.checkBalanceUpdate();
                case 1:
                  balance = _context3.v;
                  _this3.render((_document$querySelect = document.querySelector('#qrcode2')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.innerHTML);
                  setTimeout(function () {
                    document.getElementById('check-balance').classList.add('refreshed');
                    setTimeout(function () {
                      if (document.getElementById('check-balance')) {
                        document.getElementById('check-balance').classList.remove('refreshed');
                      }
                    }, 5000);
                  }, 5);
                case 2:
                  return _context3.a(2);
              }
            }, _callee3);
          }));
          return function (_x2) {
            return _ref3.apply(this, arguments);
          };
        }();
      }
      if (document.getElementById('check-history')) {
        document.getElementById('check-history').onclick = function (e) {
          e.currentTarget.classList.add('refreshing');
          _this3.mod.checkHistory(function () {
            var _document$querySelect2;
            _this3.render((_document$querySelect2 = document.querySelector('#qrcode2')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.innerHTML);
            setTimeout(function () {
              document.getElementById('check-history').classList.add('refreshed');
              setTimeout(function () {
                if (document.getElementById('check-history')) {
                  document.getElementById('check-history').classList.remove('refreshed');
                }
              }, 5000);
            }, 5);
          });
        };
      }

      /////////////////////////
      /// Pagination events....
      /////////////////////////
      /*
      const paginationNumbers = document.getElementById('pagination-numbers');
      const listItems = document.querySelectorAll('.mixin-txn-his-container .saito-table-row');
      const nextButton = document.getElementById('next-button');
      const prevButton = document.getElementById('prev-button');
       const paginationLimit = 10;
      const pageCount = Math.ceil(listItems.length / paginationLimit);
      let currentPage = 1;
       if (listItems.length == 0) {
        document.querySelector('.pagination-container').classList.add('disabled');
      }
       const disableButton = (button) => {
        button.classList.add('disabled');
        //button.setAttribute("disabled", true);
      };
       const enableButton = (button) => {
        button.classList.remove('disabled');
        //button.removeAttribute("disabled");
      };
       const handlePageButtonsStatus = () => {
        if (currentPage === 1) {
          disableButton(prevButton);
        } else {
          enableButton(prevButton);
        }
         if (pageCount === currentPage) {
          disableButton(nextButton);
        } else {
          enableButton(nextButton);
        }
      };
       const handleActivePageNumber = () => {
        document.querySelectorAll('.pagination-number').forEach((button) => {
          button.classList.remove('active');
          const pageIndex = Number(button.getAttribute('page-index'));
          if (pageIndex == currentPage) {
            button.classList.add('active');
          }
        });
      };
       const appendPageNumber = (index) => {
        const pageNumber = document.createElement('div');
        pageNumber.className = 'pagination-number';
        pageNumber.innerHTML = index;
        pageNumber.setAttribute('page-index', index);
        pageNumber.setAttribute('aria-label', 'Page ' + index);
         paginationNumbers.appendChild(pageNumber);
      };
       const getPaginationNumbers = () => {
        for (let i = 1; i <= pageCount; i++) {
          appendPageNumber(i);
        }
      };
       const setCurrentPage = (pageNum) => {
        currentPage = pageNum;
         handleActivePageNumber();
        handlePageButtonsStatus();
         const prevRange = (pageNum - 1) * paginationLimit;
        const currRange = pageNum * paginationLimit;
         listItems.forEach((item, index) => {
          item.classList.add('hidden');
          if (index >= prevRange && index < currRange) {
            item.classList.remove('hidden');
          }
        });
      };
       getPaginationNumbers();
      setCurrentPage(1);
       prevButton.addEventListener('click', () => {
        if (currentPage > 1) {
          setCurrentPage(currentPage - 1);
        }
      });
       nextButton.addEventListener('click', () => {
        if (currentPage < pageCount) {
          setCurrentPage(currentPage + 1);
        }
      });
       document.querySelectorAll('.pagination-number').forEach((button) => {
        const pageIndex = Number(button.getAttribute('page-index'));
         if (pageIndex) {
          button.addEventListener('click', () => {
            setCurrentPage(pageIndex);
          });
        }
      });
       */
    }
  }]);
}();
module.exports = Details;